// Header.js
import React, {useState, useEffect} from 'react';
import {Link, useNavigate} from 'react-router-dom';

import {googleLogout} from '@react-oauth/google';
import LoginPopup from './LoginPopup';
import AnimatedLogo from './AnimatedLogo';
import ProfileDropdown from './ProfileDropdown';
import {jwtDecode} from "jwt-decode";
import '../styles/Header.css';


const Header = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [user, setUser] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);

    const navigate = useNavigate();

    // Récupérer l'utilisateur depuis le localStorage lors du montage
    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    const toggleSidebar = () => setSidebarOpen(prev => !prev);

    const handleNavigation = (path) => {
        navigate(path);
        setSidebarOpen(false);
    };

    // Gestion de la connexion classique (à adapter avec votre backend si nécessaire)
    const handleLogin = (identifier, password) => {
        console.log('Tentative de login :', identifier, password);
        // Ici, vous pouvez ajouter la logique d'authentification classique.
        // Pour cet exemple, nous simulerons une connexion avec un utilisateur fictif.
        const fakeUser = {
            name: identifier,
            email: `${identifier}@exemple.com`,
            picture: '', // Vous pouvez ajouter une image par défaut
            token: 'fake-token'
        };
        setUser(fakeUser);
        localStorage.setItem('user', JSON.stringify(fakeUser));
        setShowLogin(false);
    };

    // Gestion de la connexion via Google OAuth
    const handleGoogleLogin = (credentialResponse) => {
        try {
            const decoded = jwtDecode(credentialResponse.credential);
            console.log('JWT décodé:', decoded);
            const googleUser = {
                name: decoded.name,
                email: decoded.email,
                picture: decoded.picture,
                token: credentialResponse.credential
            };
            setUser(googleUser);
            localStorage.setItem('user', JSON.stringify(googleUser));
            setShowLogin(false);
        } catch (error) {
            console.error('Erreur lors de la connexion Google:', error);
        }
    };

    // Déconnexion
    const handleLogout = () => {
        setUser(null);
        localStorage.removeItem('user');
        googleLogout();
        setShowDropdown(false);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768 && sidebarOpen) {
                setSidebarOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [sidebarOpen]);

    const pages = [
        {path: '/pages/news', label: 'News'},
        {path: '/pages/cinemas', label: 'Cinémas'},
        {path: '/pages/trailers', label: 'Trailers'},
        {path: '/pages/apropos', label: 'À propos'}
    ];

    return (
        <>
            <header className="site-header">
                <div className="header-container">
                    <div className="logo">
                        <h1>
                            <Link to="/"><AnimatedLogo/></Link>
                        </h1>
                    </div>
                    {/* Desktop Navigation */}
                    <nav className="desktop-nav">
                        <ul className="nav-links">
                            {pages.map((page) => (
                                <li key={page.path}>
                                    <Link to={page.path}>{page.label}</Link>
                                </li>
                            ))}
                        </ul>
                        {/* Affichage conditionnel du bouton Account ou Profil
                        {user ? (
                            <div className="profile-container">
                                <button
                                    className="mobile-profile-btn"
                                    onClick={() => setShowDropdown(prev => !prev)}
                                >
                                    <span className="profile-initial">
                        {user.name.charAt(0).toUpperCase()}
                    </span>
                                </button>
                                <ProfileDropdown
                                    visible={showDropdown}
                                    onLogout={handleLogout}
                                    onClose={() => setShowDropdown(false)}
                                />
                            </div>
                        ) : (
                            <button className="account-btn" onClick={() => setShowLogin(true)}>
                                Account
                            </button>
                        )} */}
                    </nav>

                    {/* Mobile Hamburger */}
                    <button
                        className={`hamburger ${sidebarOpen ? 'active' : ''}`}
                        onClick={toggleSidebar}
                        aria-label="Menu"
                    >
            <span className="hamburger-box">
              <span className="hamburger-inner"></span>
            </span>
                    </button>
                </div>
            </header>

            {/* Mobile Sidebar */}
            <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
                <div className="sidebar-header">
                    <h1>
                        <Link to="/">📽️ 🎞️ 🎬</Link>
                    </h1>
                    <button
                        className="close-btn"
                        onClick={toggleSidebar}
                        aria-label="Fermer"
                    >
                        &times;
                    </button>
                </div>
                <nav className="sidebar-nav">
                    <ul>
                        {pages.map((page) => (
                            <li key={page.path} onClick={() => {
                                handleNavigation(page.path);
                                toggleSidebar(); // Fermer le sidebar après navigation
                            }}>
                                <Link to={page.path}>{page.label}</Link>
                            </li>
                        ))}
                    </ul>
                    {/* Mobile Sidebar
                    {user ? (
                        <div className="mobile-profile-section">
                            <button
                                className="mobile-profile-btn"
                                onClick={() => setShowDropdown(prev => !prev)}
                            >
                    <span className="profile-initial">
                        {user.name.charAt(0).toUpperCase()}
                    </span>
                            </button>

                            {showDropdown && (
                                <ProfileDropdown
                                    visible={showDropdown}
                                    mobile
                                    onLogout={handleLogout}
                                    onClose={() => setShowDropdown(false)}
                                />
                            )}
                        </div>
                    ) : (
                        <button
                            className="sidebar-account"
                            onClick={() => {
                                setShowLogin(true);
                                toggleSidebar();
                            }}
                        >
                            Account
                        </button>
                    )}*/}
                </nav>
            </aside>

            {sidebarOpen && <div className="overlay" onClick={toggleSidebar}/>}

            {/* Popup de Login */}
            <LoginPopup
                isOpen={showLogin}
                onClose={() => setShowLogin(false)}
                onLogin={handleLogin}
                onGoogleLogin={handleGoogleLogin}
            />
        </>
    );
};

export default Header;
